import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicTenancyExtend({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M11.45 4.4l.08.07 3 3c.27.27.3.68.07.98l-.07.08-3 3a.75.75 0 01-1.13-.98l.07-.08 1.72-1.72H3.8l1.72 1.72.07.08a.75.75 0 01-1.13.98l-3-3-.07-.08a.75.75 0 01.07-.98l3-3 .08-.07c.3-.22.71-.2.98.07l.07.08c.22.3.2.71-.07.98L3.81 7.25h8.38l-1.72-1.72a.75.75 0 01-.07-.98l.07-.08a.75.75 0 01.98-.07z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicTenancyExtend.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicTenancyExtend.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicTenancyExtend svgRef={ref} {...props} />
));
export default ForwardRef;
